<template>
	<div class="calculator__customizer">
		<h5 class="calculator__customizer-title">{{ $t('customDistribution') }}</h5>

		<div class="calculator__customizer-columns">
			<div class="calculator__customizer-form">
				<p
					v-if="$t('customDistributionHint')"
					class="calculator__customizer-text"
					v-html="$t('customDistributionHint')"
				></p>

				<ul class="calculator__customizer-items">
					<li
						v-for="share in $store.getters.fittedShares"
						:key="share.key"
						class="calculator__customizer-item"
					>
						<CustomizerItem :share="share" />
					</li>
				</ul>
			</div>

			<div class="calculator__customizer-graph">
				<Graph :shares="$store.getters.fittedShares" :title="$t('customDistribution')" />
			</div>
		</div>

		<Navigation
			:returnLabel="returnLabel"
			:onReturn="onReturn"
			:continueLabel="continueLabel"
			:onContinue="onContinue"
			continueEventId="register"
		/>
	</div>
</template>

<script>
import CustomizerItem from './CustomizerItem.vue';
import Graph from './Graph.vue';
import Navigation from './Navigation.vue';

export default {
	name: 'Customizer',
	components: { Graph, CustomizerItem, Navigation },
	computed: {
		returnLabel() {
			const returnLabel =
				this.$store.state.customNavigation.returnLabel || this.$t(`goToConfigurator`);

			return returnLabel;
		},
		continueLabel() {
			const continueLabel =
				this.$store.state.customNavigation.ctaLabel || this.$t(`goToWill`);

			return continueLabel;
		},
		continueTarget() {
			const continueTarget = this.$store.state.customNavigation.ctaTarget;

			return continueTarget;
		}
	},
	methods: {
		onReturn() {
			this.$store.commit('showConfigurator');
		},
		async onContinue() {
			const form = this.$el.closest('form');

			if (form && form.Bouncer) {
				const summary = form.querySelector('[name="calculator"]');
				const invalid = await form.Bouncer.validateAll(summary.parentNode);

				if (invalid.length) {
					return;
				}
			}

			if (this.continueTarget) {
				window.open(this.continueTarget, '_blank');
			} else {
				this.$el.dispatchEvent(
					new CustomEvent('LN:showNextStep', {
						bubbles: true
					})
				);
			}
		}
	}
};
</script>

<style>
@import url('../assets/css/variables.css');

.calculator__customizer-title {
	font-size: 35px;
	font-weight: 200;
	margin: 0 0 26px 0;
}

.calculator__customizer-text.calculator__customizer-text {
	margin: 0 0 48px 0;
}

.calculator__customizer-graph {
	margin-top: 48px;
	background: var(--color-background-dark);
	padding: 1.5rem;
}

.calculator__customizer-items {
	list-style-type: none;
	padding: 0;
	margin: 0;
	margin-top: 24px;
	border-top: 1px solid rgba(0, 0, 0, 0.1);
	padding-top: 24px;
}

/* Desktop */
@media (min-width: 64rem) {
	.calculator__customizer-columns {
		display: flex;
		margin-left: calc(-1 * var(--spacing));
		margin-right: calc(-1 * var(--spacing));
	}

	.calculator__customizer-form {
		flex: 0 0 66.667%;
		padding: 0 var(--spacing);
		box-sizing: border-box;
		min-width: 0;
	}

	.calculator__customizer-graph {
		flex-basis: 33.333%;
		min-width: 0;
		margin-right: var(--spacing);
		margin-top: 0;
		position: sticky;
		top: 0;
		align-self: flex-start;
	}
}
</style>
